import React from 'react';

export type UserType = Readonly<{
  hasDetails: boolean;
  membershipNumber: string;
  surname: string;
}>;

type UserConfig = {
  currentUser: UserType;
  updateCurrentUser: (user: UserType) => void;
  logout: () => void;
};

export const UserDefault: UserType = {
  hasDetails: false,
  membershipNumber: '',
  surname: '',
};

export const UserContext = React.createContext<UserConfig>({
  currentUser: UserDefault,
  updateCurrentUser: () => {},
  logout: () => {},
});
